export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-6 md:mb-8">
            Votre réparateur de fenêtre à Hœnheim
          </h2>
          <div className="space-y-5 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Hœnheim a gardé son âme de village alsacien malgré la proximité de Strasbourg. Rues bordées de maisons individuelles, jardins fleuris et petites résidences : chaque fenêtre raconte une époque. Nos techniciens réparent le mécanisme chez vous, sans remplacer l'ensemble.
            </p>
            <p>
              Hœnheim, à la porte de Strasbourg, a su garder son âme de village. Les rues sont bordées de maisons individuelles avec jardins, de petits immeubles et de résidences paisibles. Les fenêtres y sont aussi variées que l'habitat : PVC récent, bois ancien, aluminium moderne. Nous connaissons bien cette commune et intervenons chez vous.
            </p>
            <p>
              À quelques minutes de Strasbourg, Hœnheim bénéficie d'une réactivité exceptionnelle. Le déplacement est gratuit, le diagnostic est gratuit, la pièce de remplacement est comprise et chaque réparation est garantie 10 ans. Nous connaissons le parc immobilier local, des quartiers pavillonnaires aux petites résidences collectives.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}